// src/lib/ocrWorker.js
let workerPromise = null;

async function createOcrWorker() {
  const mod = await import('tesseract.js');
  const Tesseract = mod.default ?? mod;

  // v6: 言語はここで指定。load/loadLanguage/initialize は不要＆存在しない
  const worker = await Tesseract.createWorker('eng');

  // 必要ならパラメータ（whitelist/psm など）は引き続き設定OK
  await worker.setParameters({
    tessedit_char_whitelist: '0123456789xX×,*., ',
    tessedit_pageseg_mode: '6',
    user_defined_dpi: '300',
  });
  return worker;
}

export async function getOcrWorker() {
  if (!workerPromise) workerPromise = createOcrWorker();
  return workerPromise;
}

export async function recognize(blobOrBuffer) {
  const worker = await getOcrWorker();
  const { data } = await worker.recognize(blobOrBuffer);
  return { text: data.text || '', confidence: data.confidence || 0 };
}

export async function terminateOcrWorker() {
  if (!workerPromise) return;
  const worker = await workerPromise;
  workerPromise = null;
  if (worker?.terminate) await worker.terminate();
}
